import dialog from "../../../../components/Modal/dialog";
import PageContainer from "../../../../components/PageContainer/PageContainer";
import Progress from "../../../../components/Progress";
import { getObjectUseCase, upsertUseCase } from "../../../../usecases/object";
import { restUseCase } from "../../../../usecases/rest";
import FormUtils from "../../../../utils/classUtils/FormUtils";
import createPromise from "../../../../utils/createPromise";
import withRouter from "../../../../utils/withRouter";
import WithResult from "../negative-records-list/components/WithResult";
import Card from "./components/Card";
import Item from "./components/Item";
import RequestAccessModal from "./components/RequestAccessModal";
import {
  accessHistoryBody,
  accessHistoryHeader,
} from "./data/accessHistoryDetails";
import { caseDetailsBody, caseDetailsHeader } from "./data/caseDetails";
import {
  contactDetailsBody,
  contactDetailsHeader,
} from "./data/contactDetails";
import { recordDetailsBody, recordDetailsheader } from "./data/recordDetails";
import NegativeRecordsCompanyViewPresenter from "./NegativeRecordsCompanyViewPresenter";

const tooltipStyle = {
  position: "absolute",
  top: "-30px",
  left: "50%",
  transform: "translateX(-50%)",
  backgroundColor: "black",
  color: "white",
  padding: "5px 10px",
  borderRadius: "5px",
  fontSize: "0.75rem",
  whiteSpace: "nowrap",
  zIndex: "1000",
  pointerEvents: "none",
};

class NagativeRecordsCompanyViewPage extends FormUtils {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      object: {},
      courtCases: [],
      modalState: false,
      accessRequestObject: {},
      requestAccessObject: {},
      contactPersons: [],
      accessHistory: [],
      userAffBranch: [],
      showTooltip: false,
      outSideClient: [],
    };
    this.presenter = new NegativeRecordsCompanyViewPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase(),
      restUseCase()
    );
  }

  componentDidMount() {
    this.presenter.componentDidMount();
  }

  setOutSideClient(response) {
    this.setState({ outSideClient: response });
  }

  handleMouseEnter = () => {
    this.setState({ showTooltip: true });
  };

  handleMouseLeave = () => {
    this.setState({ showTooltip: false });
  };

  getCollectionName() {
    return "records";
  }

  onClickVew(index) {
    this.presenter.onClickView(index);
  }

  setCourtCases(cases) {
    this.setState({ courtCases: cases });
  }

  setContactPersons(contacts) {
    this.setState({ contactPersons: contacts });
  }

  setAccessRequestObject(accessRequestObject) {
    this.setState({ accessRequestObject });
  }

  setAccessHistory(history) {
    this.setState({ accessHistory: history });
  }

  setUserAffBranch(user) {
    this.setState({ userAffBranch: user });
  }

  async onRequestAccess() {
    try {
      await this.showRequestAccessModal();
      await this.presenter.submitRequest();
    } catch (error) {}
  }

  setRequestAccessObject(requestObject) {
    this.setState({ requestAccessObject: requestObject });
  }

  onRequestAccessChange(value, field) {
    this.presenter.onRequestAccessChange(value, field);
  }

  handleViewAllAccessHistory() {
    const object = this.state.object;

    this.navigateTo(`history/${object.searchNameId}`);
  }

  showRequestAccessModal() {
    const promise = createPromise();
    dialog.fire({
      html: (
        <RequestAccessModal
          onRequestAccessChange={this.onRequestAccessChange.bind(this)}
          requestAccessObject={this.state.requestAccessObject}
        />
      ),
      positiveButton: "Request Access",
      negativeButton: "Cancel",
      onPositiveClick: () => {
        promise.resolve();
      },
      onNegativeClick: () => {
        promise.reject();
      },
    });

    return promise;
  }

  render() {
    const {
      object,
      contactPersons,
      accessHistory,
      accessRequestObject,
      loading,
      courtCases,
      userAffBranch,
      showTooltip,
      outSideClient,
    } = this.state;
    const currentUser = this.getCurrentUser();
    // console.log("try user", userAffBranch);
    // console.log("try", object);
    // console.log("court cases", courtCases);
    // console.log("outside", outSideClient);

    const userAffiliateCode =
      userAffBranch?.[0]?.affiliate?.code || userAffBranch?.[0]?.affiliate?.id;
    const userBranchCode =
      userAffBranch?.[0]?.branch?.code || userAffBranch?.[0]?.branch?.id;

    const lockedAffiliateId =
      object?.lockedTo?.affiliate?.code || object?.lockedTo?.affiliate?.id;
    const lockedBranchId =
      object?.lockedTo?.branch?.code || object?.lockedTo?.branch?.id;

    const shouldDisableButton =
      userAffiliateCode === lockedAffiliateId &&
      userBranchCode === lockedBranchId;

    const shouldShow = userAffBranch[0]?.id === object?.lockedTo?.id;

    const outside = outSideClient.map((out) => out.name);

    // console.log("out name", outside);

    const financeCompanies = outside;
    // [
    //   // "GLOBAL SME",
    //   // "WISEFUND FINANCE CORPORATION",
    //   // "GLOBAL DOMINION FINANCE INCORPORATED",
    //   // "ASIALINK FINANCE CORPORATION",
    //   // "AFC 2ND HAND CAR LOAN",
    //   // "AFC TRUCK LOAN",
    //   // "CEPAT KREDIT INC.",
    //   // "SOUTHASIALINK FINANCE CORP",
    //   // "SOUTHASIALINK MBL",
    //   // "SOUTHASIALINK CREDIT CORP",
    //   // "SOUTHASIALINK SPECIAL ACCOUNTS",
    //   // "ANNAPOLIS FINANCE INC",
    //   // "GLOBAL CEBUANA FINANCE INC",
    //   // "CEBUANA CYCLE FINANCING INC.",
    //   "AVVANZ PHILIPPINES",
    //   "LENDELL OUTSOURCING SOLUTIONS INC.",
    //   "Lendell Outsourcing Solutions, Inc",
    //   "ABUEMP",
    //   "ABU-EMP",
    //   "1 PENTAGON AND CREDIT LENDING CORPORATION",
    //   "1-PENTAGON CREDIT AND LENDING CORPORATION",
    //   "GLOBAL 8 FINANCE",
    //   "GLOBAL8 FINANCE INC",
    //   "Q2",
    //   "QUAERITO QUALITAS INC.",
    //   "VANGUARD SCREENING SOLUTION INC",
    //   "VANGUARD COLLECTION MANAGEMENT INC.",
    //   "STANDARD INSURANCE",
    //   "Standard Insurance",
    // ];

    const userName = userAffBranch?.[0]?.affiliate?.name;
    const isFinance = financeCompanies.includes(userName);

    return (
      <PageContainer
        title="Negative Records Simple Search"
        navigateBack={this.navigateBack.bind(this)}
      >
        {loading ? (
          <div className="w-100 h-100 justify-content-center align-items-center">
            <Progress />;
          </div>
        ) : (
          <>
            <div className="d-flex w-100 justify-content-between align-items-center pb-1">
              {object.lockedTo?.id !== currentUser.id ? (
                <>
                  <p style={{ fontSize: ".875rem" }}>
                    <span style={{ fontSize: "1rem" }}>
                      <i class="bi bi-info-circle-fill pe-2 text-secondary"></i>
                    </span>
                    Access to this record is locked. Below are the details for
                    your reference
                  </p>
                  {/* <button
                    className={`btn ${
                      accessRequestObject ? "btn-light" : "btn-secondary"
                    }`}
                    disabled={accessRequestObject}
                    onClick={this.onRequestAccess.bind(this)}
                    style={{ fontSize: ".875rem" }}
                  >
                    {accessRequestObject ? "Under Review" : "Request Access"}
                  </button> */}
                  <div
                    style={{ position: "relative", display: "inline-block" }}
                    onMouseEnter={
                      shouldDisableButton
                        ? this.handleMouseEnter.bind(this)
                        : this.handleMouseEnter.bind(this)
                    }
                    onMouseLeave={this.handleMouseLeave.bind(this)}
                  >
                    {!isFinance && (
                      <button
                        className={`btn ${
                          accessRequestObject ? "btn-light" : "btn-secondary"
                        }`}
                        disabled={accessRequestObject || shouldDisableButton}
                        onClick={this.onRequestAccess.bind(this)}
                        style={{ fontSize: ".875rem" }}
                      >
                        {accessRequestObject
                          ? "Under Review"
                          : "Request Access"}
                      </button>
                    )}
                    {isFinance && (
                      <WithResult caseInfo={object} courtCases={courtCases} />
                    )}

                    {shouldDisableButton && showTooltip && (
                      <div style={tooltipStyle}>
                        Locked by your affiliate and branch.
                      </div>
                    )}
                  </div>
                </>
              ) : (
                <WithResult caseInfo={object} courtCases={courtCases} />
                // <div></div>
              )}
            </div>
            <Card
              header={recordDetailsheader}
              body={recordDetailsBody(object)}
            />
            {!shouldShow ? (
              <>
                {/* <Card
                  header={caseDetailsHeader}
                  body={caseDetailsBody(courtCases)}
                  label="Court Cases"
                  headerValue={courtCases.length}
                />
                <div className="mt-3 d-flex flex-column gap-4">
                  <Item label="Bounce Check" value={0} />
                  <Item label="Watch List" value={0} />
                  <Item label="Telecoms" value={0} />
                </div>

                <div className="mt-3 d-flex flex-column gap-4">
                  <Item label="Declined" value={0} />
                  <Item label="Delinquent" value={0} />
                </div> */}
              </>
            ) : (
              <>
                <Card
                  header={accessHistoryHeader}
                  body={accessHistoryBody(accessHistory)}
                  label="Access History"
                  // rightButtonLabel="View All"
                  rightButtonHandler={this.handleViewAllAccessHistory.bind(
                    this
                  )}
                />
                <Card
                  header={contactDetailsHeader}
                  body={contactDetailsBody(contactPersons)}
                  label="Contact Person"
                />
              </>
            )}
          </>
        )}
      </PageContainer>
    );
  }
}

export default withRouter(NagativeRecordsCompanyViewPage);
